import { Component } from '@angular/core';
import { AppUpdateService } from './core/services/app-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'nazox';

  constructor(appUpdateService: AppUpdateService) {
    appUpdateService.init();
  }
}
